import React from 'react'
import ErrorPageComponent from 'src/components/errors/ErrorPageComponent';

const ErrorPage = () => {
    return (
        <>
            <ErrorPageComponent />
        </>
    )
}

export default ErrorPage